import React from "react";
import { Auth } from "aws-amplify";
import { Card, Button, Form, Input, notification } from "antd";
import { validateUserPassword } from "../../utils";

interface ICustomForgotPasswordVerificationState {
  loading: boolean;
  password: string;
  verificationCode: string;
}

interface ICustomForgotPasswordVerificationProps {
  onAuthChange: (state: string, e: any) => void;
  email: string;
}

class CustomForgotPasswordVerification extends React.Component<
  ICustomForgotPasswordVerificationProps,
  ICustomForgotPasswordVerificationState
> {
  state: ICustomForgotPasswordVerificationState = {
    loading: false,
    password: "",
    verificationCode: ""
  };

  validate = () => {
    const { password, verificationCode } = this.state;
    let errors: string[] = validateUserPassword(password);
    if (verificationCode === "") errors.push("Verification code cannot be empty");

    if (errors.length > 0) {
      notification.error({
        message: "Password Validation Error",
        description: (
          <ul>
            {errors.map((error, index) => (
              <li key={index}>{error}</li>
            ))}
          </ul>
        )
      });
      return false;
    }
    return true;
  };

  handleSubmit = async (e: any) => {
    e.preventDefault();
    if (!this.validate()) return;
    this.setState({ loading: true });
    try {
      await Auth.forgotPasswordSubmit(
        this.props.email,
        this.state.verificationCode,
        this.state.password
      );
      this.props.onAuthChange("signIn", {});
    } catch (e) {
      this.setState({ loading: false });
      if (e.code === "InvalidPasswordException") {
        notification.error({
          message: e.code,
          description: e.message
        });
      } else if (e.code === "LimitExceededException") {
        notification.error({
          message: e.code,
          description: e.message
        });
      }
      console.log(e);
    }
  };

  render() {
    const { loading, password, verificationCode } = this.state;
    const { email } = this.props;
    return (
      <div className="SignIn-Container">
        <Card
          className="SignIn-Card"
          title={
            <div style={{ textAlign: "center" }}>
              <img src="/logo-ketrics.png" alt="" width="300" />
            </div>
          }
        >
          <h3>Reset your password</h3>
          <Form layout="vertical">
            <Form.Item label="Email">
              <Input size="large" value={email} disabled={true} />
            </Form.Item>
            <Form.Item label="Password">
              <Input
                size="large"
                type="password"
                value={password}
                onChange={(e) => this.setState({ password: e.target.value })}
              />
            </Form.Item>
            <Form.Item label="Verification Code">
              <Input
                size="large"
                value={verificationCode}
                onChange={(e) => this.setState({ verificationCode: e.target.value })}
                onPressEnter={this.handleSubmit}
              />
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                size="large"
                style={{ width: "100%" }}
                onClick={this.handleSubmit}
                loading={loading}
                disabled={loading}
              >
                Submit
              </Button>
            </Form.Item>

            <div style={{ textAlign: "left" }}>
              <Button
                type="link"
                size="large"
                onClick={() => this.props.onAuthChange("signIn", {})}
              >
                Back to Sign In
              </Button>
            </div>
          </Form>
        </Card>
      </div>
    );
  }
}

export default CustomForgotPasswordVerification;
